// extracted by mini-css-extract-plugin
export default {"main":"privacy_main__-nMMA"};